import { Icon } from '@platform/components';
import { HeaderFooterLayout } from '../app';
import FlexibleLink from '../util/FlexibleLink';

export type DirectoryBackLink = {
  label: string;
  href: string;
};

export const DirectoryLayout = ({
  children,
  backLink,
}: {
  children: React.ReactNode;
  backLink?: DirectoryBackLink;
}) => {
  return (
    <HeaderFooterLayout useDashboardHeader withSidebar={false}>
      <div className='md:-mt-12'>
        {backLink && (
          <FlexibleLink
            href={backLink.href}
            type='internal'
            className='w-fit flex items-center gap-1.5 px-8 py-4 text-sm font-semibold text-brand-500 hover:underline'
          >
            <Icon type='arrow-left' size='20' stroke='brand-500' />
            {backLink.label}
          </FlexibleLink>
        )}
        <div className='min-h-[1280px] relative bg-white'>{children}</div>
      </div>
    </HeaderFooterLayout>
  );
};
